import Grid from '@material-ui/core/Grid'
import React, { PropsWithChildren } from 'react'
import { CreditUnionIcon, IconCodeType } from '../icon/CreditUnionIcon'
import { Link, LinkProps } from '../link/link'
import { StyledCardContainer, StyledTitleText, StyledTitleTextContainer } from './styledNavDropdownUtilityBar'

export type UtilityBarCardProps = React.ComponentProps<typeof StyledCardContainer> & Pick<LinkProps, 'href'> & {
  title: string
  iconCode: IconCodeType
  target: boolean
}

export const UtilityBarCard: React.FC<PropsWithChildren<UtilityBarCardProps>> = ({ title, iconCode, href, children, target, ...props }) => {
  return (
    <StyledCardContainer {...props}>
      <Link href={href} target={target ? '_blank' : '_self'}>
        <StyledTitleTextContainer>
          <StyledTitleText title={title}>
            {title}
          </StyledTitleText>
        </StyledTitleTextContainer>
        <Grid title={title} item>
          <CreditUnionIcon height={26} width={26} iconCode={iconCode} />
        </Grid>
      </Link>
    </StyledCardContainer>
  )
}